import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const container: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  maxWidth: '1200px',
  minHeight: '100vh',
  margin: '0 auto',
  p: spacing(7),
};

export default container;
